import { useState } from "react";

import { MaintainCard } from "../components/MaintainCard";
import { QueuePager } from "../components/QueuePager";
import { EmptyCard, QueryErrorState, TabHeading, TabSkeleton } from "../components/tab-states";
import { useApprovalsPage } from "../data/queries";

const PAGE_SIZE = 100;

/** Keep-strategy directives — read-only, and said to be. */
export function MaintainTab() {
  const [offset, setOffset] = useState(0);
  const page = useApprovalsPage({ scope: "maintain", limit: PAGE_SIZE, offset });
  const total = page.data?.total ?? 0;

  return (
    <div className="flex flex-col gap-4">
      <TabHeading
        title="Maintain"
        description="Keep-strategy directives. No action needed, shown read-only for audit."
        aside={page.data ? `${total.toLocaleString("en-US")} directives` : undefined}
      />
      {page.isPending ? (
        <TabSkeleton />
      ) : page.isError ? (
        <QueryErrorState title="Could not load maintain directives" onRetry={() => page.refetch()} />
      ) : page.data.items.length === 0 ? (
        <EmptyCard label="No maintain directives." />
      ) : (
        <>
          <div className={`grid gap-4 lg:grid-cols-2 ${page.isFetching ? "opacity-60" : ""}`}>
            {page.data.items.map((proposal) => (
              <MaintainCard key={proposal.proposal_id} proposal={proposal} />
            ))}
          </div>
          <QueuePager
            offset={offset}
            pageSize={PAGE_SIZE}
            total={total}
            busy={page.isFetching}
            onOffset={setOffset}
          />
        </>
      )}
    </div>
  );
}
